<div class="hiperio-registration-config-details-view-container"  fxLayout="column" fxLayoutGap="15px"  *ngIf="hiperioRegistrationConfigObject">


  <div fxLayout="row" fxLayoutGap="15px">

    <button
      [disabled]="!(userPermissions | async).hiperio?.write"
      (click)="changeRegistration()"
      mat-stroked-button color="primary"
    ><mat-icon>edit</mat-icon> <span> Zmiana rejestracji</span></button>

    <button
      [disabled]="!(userPermissions | async).hiperio.write || !parameter"
      (click)="changeParameter()"
      mat-stroked-button color="primary"
    ><mat-icon>edit</mat-icon> <span> Zmiana parametrów</span></button>


    <button
      mat-stroked-button
      [style.visibility]="'hidden'"
    ><span>edit</span></button>


  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" style=" top: 55px;">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane TU </h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="TU" [value]="hiperioRegistrationConfigObject.insuranceCompany?.name"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Firma" [value]="hiperioRegistrationConfigObject.registration?.contract?.company?.name"></app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>


    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" >
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane konta Hiperio</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Nazwa użytkownika" [value]="hiperioRegistrationConfigObject.ofwca.hiperioEmail"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Imię i nazwisko OFWCA" [value]="hiperioRegistrationConfigObject.ofwca.fullName"></app-detail>
              </div>
            </div>


          </mat-card>
        </div>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" style=" top: 55px;">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane rejestracji </h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Imię i nazwisko OFWCA" [value]="hiperioRegistrationConfigObject.registration?.ofwca?.fullName"></app-detail>
              </div>

              <div fxFlex="50">
                <button mat-raised-button [ngClass]="hiperioRegistrationConfigObject.registration?.status?.color + '-button'">{{hiperioRegistrationConfigObject.registration?.status?.name}}</button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" style=" top: 55px;">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane z Hiperio  </h3>
            </div>
            <div *ngFor="let credential of credentialDataList " fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="100">
                <app-detail [header]="credential.name" [value]="credential.value"></app-detail>
              </div>

            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
